import { t } from '../../services/i18n';

export const DATE_FORMAT = 'MMM d, yyyy';
export const DEFAULT_MIN_DATE = new Date('1978-01-01');
export const TODAY_DATE = new Date();
export const DEFAULT_MONTHS_SHOWN = 2;

export const COMPARISON_TYPES = {
  previousPeriod: 'previousPeriod',
  previousYear: 'previousYear',
  previousPeriods: 'previousPeriods',
};

export const COMPARE_PERIODS_OPTIONS = (
  includeMultiPeriodsComparison: boolean
) => [
  {
    label: t('calendar:ComparePeriods.period', 'Previous Period'),
    value: 'previousPeriod',
    hide: includeMultiPeriodsComparison,
  },
  {
    label: t('calendar:ComparePeriods.periods', 'Previous Period(s)'),
    value: 'previousPeriods',
    hide: !includeMultiPeriodsComparison,
  },
  {
    label: t('calendar:ComparePeriods.year', 'Previous Year'),
    value: 'previousYear',
  },
];

export const MULTI_PERIODS_OPTIONS = Array.from({ length: 11 }).map((_, i) => ({
  value: i + 1,
  label:
    i === 0
      ? `${i + 1} ${t('calendar:RangeSelect.period', 'Period')}`
      : `${i + 1} ${t('calendar:RangeSelect.periods', 'Periods')}`,
}));
